import {VowelBasic} from "../../../SubjectData/Phonetics/Phonetics.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function VowelBasicDeck() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/VowelsNav"}/>
        <FlashcardInterface deckData={VowelBasic} title="Basic Vowels" />
     </>
);}

//resource: https://dev.to/gbadeboife/build-a-flashcard-quiz-with-react-49gi